/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImageUploadReqVo
 */
export interface ImageUploadReqVo {
    /**
     * 实体类型: SPU/SKU/SKU_PRODUCT
     * @type {string}
     * @memberof ImageUploadReqVo
     */
    entityType: string;
    /**
     * 实体ID（SPU传spuId，SKU传skuId，SKU_PRODUCT传skuProductId）
     * @type {number}
     * @memberof ImageUploadReqVo
     */
    entityId: number;
    /**
     * 图片URL（前端上传后传入）
     * @type {string}
     * @memberof ImageUploadReqVo
     */
    imageUrl: string;
    /**
     * 文件ID（预留字段，暂未使用）
     * @type {number}
     * @memberof ImageUploadReqVo
     */
    fileId?: number;
}

/**
 * Check if a given object implements the ImageUploadReqVo interface.
 */
export function instanceOfImageUploadReqVo(value: object): value is ImageUploadReqVo {
    if (!('entityType' in value) || value['entityType'] === undefined) return false;
    if (!('entityId' in value) || value['entityId'] === undefined) return false;
    if (!('imageUrl' in value) || value['imageUrl'] === undefined) return false;
    return true;
}

export function ImageUploadReqVoFromJSON(json: any): ImageUploadReqVo {
    return ImageUploadReqVoFromJSONTyped(json, false);
}

export function ImageUploadReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImageUploadReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'entityType': json['entityType'],
        'entityId': json['entityId'],
        'imageUrl': json['imageUrl'],
        'fileId': json['fileId'] == null ? undefined : json['fileId'],
    };
}

export function ImageUploadReqVoToJSON(json: any): ImageUploadReqVo {
    return ImageUploadReqVoToJSONTyped(json, false);
}

export function ImageUploadReqVoToJSONTyped(value?: ImageUploadReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'entityType': value['entityType'],
        'entityId': value['entityId'],
        'imageUrl': value['imageUrl'],
        'fileId': value['fileId'],
    };
}

